import { type UserInboxUpdatedMessageData, userInboxUpdatedMessageSchema } from './typings';

const isInboxUpdatedMessageData = (data: unknown): data is UserInboxUpdatedMessageData =>
  userInboxUpdatedMessageSchema.shape.data.safeParse(data).success;

export default isInboxUpdatedMessageData;
